import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { StepIconProps } from '@mui/material/StepIcon';
import StepLabel, { stepLabelClasses } from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { styled } from '@mui/material/styles';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import * as React from 'react';

const Connector = styled(StepConnector)(() => ({
  '&.MuiStepConnector-root': {
    left: `-50%`,
    right: `50%`,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      color: `green!important`,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: RoutalPalette.primary40,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: RoutalPalette.secondary00,
    borderRadius: 1,
  },
}));

const StepLabelComponent = styled(StepLabel)(() => ({
  [`& .${stepLabelClasses.label}`]: {
    [`&.${stepLabelClasses.active}`]: {
      paddingTop: `11px`,
      color: RoutalPalette.primary40,
    },
    paddingTop: `11px`,
    color: RoutalPalette.secondary00,
  },
}));

interface StepIconRootProps {
  completed?: boolean;
  active?: boolean;
}

const StepIconRoot = styled(`div`)<{
  ownerState: StepIconRootProps;
}>(({ ownerState }) => {
  return {
    zIndex: 1,
    width: 20,
    height: 20,
    display: `flex`,
    borderRadius: `50%`,
    justifyContent: `center`,
    alignItems: `center`,
    border: `4px solid ${RoutalPalette.secondary00}`,
    backgroundColor: `white`,
    [`&:hover`]: {
      boxShadow: `0 0 0px 8px rgba(170, 170, 170, .25)`,
      ...(ownerState.active
        ? {
            boxShadow: `0 0 0px 10px rgba(64, 104, 103, .35)`,
          }
        : {}),
    },
    ...(ownerState.completed
      ? {
          width: 20,
          height: 20,
          border: `4px solid ${RoutalPalette.primary40}`,
        }
      : {}),
    ...(ownerState.active
      ? {
          width: 20,
          height: 20,
          border: `4px solid ${RoutalPalette.primary40}`,
          backgroundColor: RoutalPalette.primary40,
        }
      : {}),
  };
});

const StepIconComponent = (props: StepIconProps) => {
  const { active, completed, className } = props;
  return <StepIconRoot ownerState={{ completed, active }} className={className} />;
};

interface IsCompletedProps {
  currentStep: string;
  steps: string[];
  activeStep?: string;
}

// Given the active step, return all the previous steps as completed including the current active step.
export const isCompleted = ({ currentStep, steps, activeStep }: IsCompletedProps) =>
  activeStep
    ? steps.findIndex((step) => step === currentStep) <= steps.findIndex((step) => step === activeStep)
    : false;

interface StepProps {
  id: string;
  label: string;
  completed: boolean;
}

interface VehiclesStepperProps {
  steps: StepProps[];
  activeStepId?: string;
  setActiveStep: (stepId: string) => void;
}

export const VehiclesStepper = ({ steps, activeStepId, setActiveStep }: VehiclesStepperProps) => {
  return (
    <Box sx={{ width: `100%` }}>
      <Stepper alternativeLabel connector={<Connector />}>
        {steps.map((step, _index) => {
          const stepProps: { completed?: boolean; active?: boolean } = {};
          const labelProps: { optional?: React.ReactNode } = {};
          const completed = isCompleted({
            steps: steps.map((s) => s.id),
            currentStep: step.id,
            activeStep: activeStepId,
          });
          const active = activeStepId === step.id;
          stepProps.completed = completed;
          stepProps.active = active;
          return (
            <Step style={{ cursor: `pointer` }} key={step.label} {...stepProps} onClick={() => setActiveStep(step.id)}>
              <StepLabelComponent StepIconComponent={StepIconComponent} style={{ cursor: `pointer` }} {...labelProps}>
                {step.label}
              </StepLabelComponent>
            </Step>
          );
        })}
      </Stepper>
    </Box>
  );
};
